import { ImportType } from 'library/ts/model/enums/config/ImportType';
import { Domain } from 'library/ts/model/enums/web/Domain';
import { ImportVO } from 'library/ts/model/vo/ImportVO';
export class IFramePlayerConstants {
    static _instance = new IFramePlayerConstants();
    constructor() {
        if (IFramePlayerConstants._instance) {
            throw new Error(this.name + ' is a Singleton and can only be accessed through ' + this.name + '.getInstance()');
        }
        IFramePlayerConstants._instance = this;
    }
    get name() {
        return 'IFramePlayerConstants';
    }
    get smartTagImportVO() {
        const utils = window?.IFramePlayer?.utilities;
        const projectInfo = window?.PlayerServicesProjectInfo;
        const appURLParsed = window?.IFramePlayer?.runtimeVO.app.parsed;
        if (!utils || !projectInfo || !appURLParsed) {
            return undefined;
        }
        let smartTagURL = `${appURLParsed.protocol}://${appURLParsed.host}/${appURLParsed.path.split('/')[1]}/${projectInfo?.app_output_dir?.tag?.value}/${projectInfo?.app_output_file?.tag?.js?.min?.value}`;
        const onReadyCallbackVO = {
            namespace: 'IFramePlayer',
            method: 'onSmartTagReady',
            sentry: false
        };
        smartTagURL = utils.URL.addParam('onReady', utils.Convert.objectEncode(onReadyCallbackVO), smartTagURL);
        smartTagURL = utils.URL.addCacheToken(smartTagURL, window?.IFramePlayer?.runtimeVO?.debug?.cacheBust || false);
        return new ImportVO(ImportType.SCRIPT, smartTagURL, window?.PlayerServicesProjectInfo?.app_namespace?.tag?.value || 'SmartTag', window);
    }
    get utagImportVO() {
        const utils = window?.IFramePlayer?.utilities;
        const projectInfo = window?.PlayerServicesProjectInfo;
        const debug = window?.IFramePlayer?.runtimeVO.debug.on;
        let utagURL = 'https://tags.tiqcdn.com/utag/cbsi/pplus/prod/utag.js';
        let utagNamespace = 'utag';
        switch (utils.URL.myDomain(window?.IFramePlayer?.runtimeVO?.top?.parsed?.host)) {
            case Domain.PPLUS:
                utagURL = projectInfo?.dependencies?.utag_pplus?.url?.regular?.value;
                utagNamespace = projectInfo.dependencies.utag_pplus.namespace.value;
                break;
            case Domain.CBSCOM:
                utagURL = projectInfo?.dependencies?.utag_cbs?.url?.regular?.value;
                utagNamespace = projectInfo.dependencies.utag_cbs.namespace.value;
                break;
        }
        const topReferrer = utils.URL.getTopReferrer();
        const utagEnv = utils.URL.getQueryField('utagEnv', topReferrer);
        if (!utils.Type.isEmpty(utagEnv) && utils.Type.isString(utagEnv) && /(prod)|(dev)|(qa)|(sandbox)/.test(utagEnv)) {
            utagURL = utagURL.replace('/prod/', `/${utagEnv}/`);
        }
        return new ImportVO(ImportType.SCRIPT, utagURL, utagNamespace, window);
    }
    get smartTagContainer() {
        return document.getElementById('smart-tag-container');
    }
    static getInstance() {
        return IFramePlayerConstants._instance;
    }
}
